export default __webpack_public_path__ + "static/media/icon_check.574eb3bc.svg";